import queryString from "query-string";
import { useRef } from "react";
import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type {
	CompanyDealTodo,
	CompanyDealTodoSearchCondition
} from "~/models/CompanyDealTodo";

const paths = {
	index: "/company_deal_todos"
};

export const buildIndexPath = (query: CompanyDealTodoSearchCondition): string =>
	queryString.stringifyUrl(
		{ query, url: paths.index },
		{ arrayFormat: "bracket", skipEmptyString: true, skipNull: true }
	);

export const useCompanyDealTodos = (
	query: CompanyDealTodoSearchCondition
): SwrReturnType<Pageable<CompanyDealTodo>> => {
	const cachedDataRef = useRef<Pageable<CompanyDealTodo> | null>(null);

	const { data, mutate, error, isLoading } = useSWR<Pageable<CompanyDealTodo>>(
		buildIndexPath(query)
	);

	if (data) {
		cachedDataRef.current = data;
	}

	return {
		data: data ?? cachedDataRef.current,
		error,
		isLoading,
		mutate
	};
};
